/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "afterAgreementCreated",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "afterAgreementTerminated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "afterAgreementUpdated",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address",
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32",
            },
        ],
        name: "approveSubscriptionTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address",
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32",
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes",
            },
        ],
        name: "approveSubscriptionWithUserDataTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "beforeAgreementCreated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "beforeAgreementTerminated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "beforeAgreementUpdated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address",
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "calculateDistributionTest",
        outputs: [
            {
                internalType: "uint256",
                name: "actualAmount",
                type: "uint256",
            },
            {
                internalType: "uint128",
                name: "newIndexValue",
                type: "uint128",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address",
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32",
            },
            {
                internalType: "address",
                name: "subscriber",
                type: "address",
            },
        ],
        name: "claimTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address",
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32",
            },
            {
                internalType: "address",
                name: "subscriber",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes",
            },
        ],
        name: "claimWithUserDataTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32",
            },
        ],
        name: "createIndexTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32",
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes",
            },
        ],
        name: "createIndexWithUserDataTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address",
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32",
            },
            {
                internalType: "address",
                name: "subscriber",
                type: "address",
            },
        ],
        name: "deleteSubscriptionTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address",
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32",
            },
            {
                internalType: "address",
                name: "subscriber",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes",
            },
        ],
        name: "deleteSubscriptionWithUserDataTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "distributeTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes",
            },
        ],
        name: "distributeWithUserDataTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address",
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32",
            },
        ],
        name: "getIndexTest",
        outputs: [
            {
                internalType: "bool",
                name: "exist",
                type: "bool",
            },
            {
                internalType: "uint128",
                name: "indexValue",
                type: "uint128",
            },
            {
                internalType: "uint128",
                name: "totalUnitsApproved",
                type: "uint128",
            },
            {
                internalType: "uint128",
                name: "totalUnitsPending",
                type: "uint128",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "agreementId",
                type: "bytes32",
            },
        ],
        name: "getSubscriptionByIDTest",
        outputs: [
            {
                internalType: "address",
                name: "publisher",
                type: "address",
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32",
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool",
            },
            {
                internalType: "uint128",
                name: "units",
                type: "uint128",
            },
            {
                internalType: "uint256",
                name: "pendingDistribution",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address",
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32",
            },
            {
                internalType: "address",
                name: "subscriber",
                type: "address",
            },
        ],
        name: "getSubscriptionTest",
        outputs: [
            {
                internalType: "bool",
                name: "exist",
                type: "bool",
            },
            {
                internalType: "bool",
                name: "approved",
                type: "bool",
            },
            {
                internalType: "uint128",
                name: "units",
                type: "uint128",
            },
            {
                internalType: "uint256",
                name: "pendingDistribution",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "subscriber",
                type: "address",
            },
        ],
        name: "listSubscriptionsTest",
        outputs: [
            {
                internalType: "address[]",
                name: "publishers",
                type: "address[]",
            },
            {
                internalType: "uint32[]",
                name: "indexIds",
                type: "uint32[]",
            },
            {
                internalType: "uint128[]",
                name: "unitsList",
                type: "uint128[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address",
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32",
            },
        ],
        name: "revokeSubscriptionTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "address",
                name: "publisher",
                type: "address",
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32",
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes",
            },
        ],
        name: "revokeSubscriptionWithUserDataTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32",
            },
            {
                internalType: "uint128",
                name: "indexValue",
                type: "uint128",
            },
        ],
        name: "updateIndexValueTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32",
            },
            {
                internalType: "uint128",
                name: "indexValue",
                type: "uint128",
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes",
            },
        ],
        name: "updateIndexValueWithUserDataTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32",
            },
            {
                internalType: "address",
                name: "subscriber",
                type: "address",
            },
            {
                internalType: "uint128",
                name: "units",
                type: "uint128",
            },
        ],
        name: "updateSubscriptionUnitsTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidToken",
                name: "token",
                type: "address",
            },
            {
                internalType: "uint32",
                name: "indexId",
                type: "uint32",
            },
            {
                internalType: "address",
                name: "subscriber",
                type: "address",
            },
            {
                internalType: "uint128",
                name: "units",
                type: "uint128",
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes",
            },
        ],
        name: "updateSubscriptionUnitsWithUserDataTest",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class IDAv1LibrarySuperAppMock__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(host, overrides) {
        return super.deploy(host, overrides || {});
    }
    getDeployTransaction(host, overrides) {
        return super.getDeployTransaction(host, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
IDAv1LibrarySuperAppMock__factory.bytecode = _bytecode;
IDAv1LibrarySuperAppMock__factory.abi = _abi;
//# sourceMappingURL=IDAv1LibrarySuperAppMock__factory.js.map